export function checkAoi(aoi) {
  if (!aoi.points) return false;
  const [lt, rb] = aoi.points;
  if (lt.x !== 0) return true;
  if (lt.y !== 0) return true;
  if (rb.x !== 30) return true;
  if (rb.y !== 30) return true;
  return false;
}
